import { useScrollTop } from '@hivebrite/react-hooks';

import { NAVIGATION } from 'hb-react/shared/apps/Events/constants/navigation';
import { RegistrationSteps } from 'hb-react/shared/apps/Events/constants/registrationSteps';
import { useRegistrationFlowContext } from 'hb-react/shared/apps/Events/contexts/RegistrationFlowContext';
import { useWithBillingStepWorkflow } from 'hb-react/shared/apps/Events/hooks/useWithBillingStepWorkflow';

export const getBreadcrumbs = ({
  currentStep,
  withBillingStepWorkflow,
  updateRegistrationFlow,
  withPaymentWorkflow,
}) => [
  {
    name: NAVIGATION.TICKET_SELECTION,
    onClick: () => {
      updateRegistrationFlow({
        currentStep: RegistrationSteps.TICKET_SELECTION_STEP,
      });
    },
    active: currentStep === RegistrationSteps.TICKET_SELECTION_STEP,
  },
  {
    name: NAVIGATION.REGISTRATION,
    onClick: () => {
      updateRegistrationFlow({
        currentStep: RegistrationSteps.TICKET_INFORMATION_STEP,
      });
    },
    active: currentStep === RegistrationSteps.TICKET_INFORMATION_STEP,
    disabled: currentStep === RegistrationSteps.TICKET_SELECTION_STEP,
    requiredExplanation: true,
  },
  ...(withBillingStepWorkflow
    ? [
        {
          name: NAVIGATION.BILLING_DETAILS,
          onClick: () => {
            updateRegistrationFlow({
              currentStep: RegistrationSteps.BILLING_INFORMATION_STEP,
            });
          },
          active: currentStep === RegistrationSteps.BILLING_INFORMATION_STEP,
          disabled: currentStep !== RegistrationSteps.BILLING_INFORMATION_STEP,
          requiredExplanation: true,
        },
      ]
    : []),
  ...(withPaymentWorkflow
    ? [
        {
          name: NAVIGATION.PAYMENT,
          disabled: true,
        },
      ]
    : []),
];

export const useNavigation = () => {
  const {
    registrationFlow: { currentStep },
    updateRegistrationFlow,
    totalPrice,
  } = useRegistrationFlowContext();

  const withBillingStepWorkflow = useWithBillingStepWorkflow();

  useScrollTop([currentStep]);

  return getBreadcrumbs({
    withBillingStepWorkflow,
    currentStep,
    updateRegistrationFlow,
    withPaymentWorkflow: totalPrice > 0,
  });
};
